import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from 'react';
import { useAudioTrack, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, dailyStateAtom, mouthShapeAtom, isTextToSpeechAtom } from '../../State';
import { StopWorkerInterval, StartWorkerInterval } from '../Util/WorkerInterval';
const MicDetect = forwardRef(({ mediaStream }, ref) => {
  //Daily系
  const localSessionId = useLocalSessionId();
  const localAudio = useAudioTrack(localSessionId);
  const mutedAudio = localAudio.isOff;

  //Recoil系
  const isTextToSpeechState = useRecoilValue(isTextToSpeechAtom);
  const setMouthShapeState = useSetRecoilState(mouthShapeAtom);
  const webcamState = useRecoilValue(webcamAtom);

  //その他
  const intervalRef = useRef(null); //インターバル処理用
  const audioContext = useRef(null); //オーディオコンテキスト
  const volumeCallback = useRef(null); //マイク3
  const isTextToSpeechRef = useRef(false);
  const [sendMicState, setSendMicState] = useState(true);
  const FPS = 100;

  //親から呼ばれる
  useImperativeHandle(ref, () => ({
    //マイクを再アクティベイト
    activateMicAgain() {
      //一度無効化
      disableMic();

      //マイクを再起動
      enableMic();
    },
  }));

  useEffect(() => {
    isTextToSpeechRef.current = isTextToSpeechState;
  }, [isTextToSpeechState]);

  useEffect(() => {
    if (localAudio.isOff) {
      //setSendMicState(false);
      disableMic();
    } else {
      if (webcamState == false) {
        // enableMic();
      }
      //setSendMicState(true);
      enableMic();
    }
  }, [mutedAudio]);

  //初期化
  useEffect(() => {
    enableMic();
    return () => disableMic(true);
  }, []);

  //マイクセットアップ
  async function enableMic() {
    //一度クリアする
    if (intervalRef.current != null) {
      //clearInterval(intervalRef.current);
      StopWorkerInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (
      audioContext.current != null &&
      mediaStream.current != null &&
      volumeCallback !== null &&
      intervalRef.current == null
    ) {
      //インターバル開始
      //intervalRef.current = setInterval(volumeCallback.current, FPS);
      intervalRef.current = StartWorkerInterval(FPS, volumeCallback.current);
      return;
    }

    if (mediaStream.current == null) {
      return;
    }

    const audioTracks = mediaStream.current.getAudioTracks();
    if (audioTracks.length < 1) {
      return;
    }

    // 初期化
    try {
      audioContext.current = new AudioContext();
      const mediaStreamAudioSourceNode = audioContext.current.createMediaStreamSource(
        mediaStream.current,
      );
      const analyserNode = audioContext.current.createAnalyser();
      //analyserNode.fftSize = 1024;
      // analyserNode.minDecibels = -127;
      // analyserNode.maxDecibels = 0;
      analyserNode.smoothingTimeConstant = 0.3;
      mediaStreamAudioSourceNode.connect(analyserNode);

      const pcmData = new Float32Array(analyserNode.fftSize);
      volumeCallback.current = () => {
        analyserNode.getFloatTimeDomainData(pcmData);
        let sumSquares = 0.0;
        for (const amplitude of pcmData) {
          sumSquares += amplitude * amplitude;
        }
        const myVolume = Math.sqrt(sumSquares / pcmData.length);
        var myVolumeM = myVolume * 100;

        if (myVolumeM < 1) {
          myVolumeM = 0;
        }

        if (isTextToSpeechRef.current == false) {
          setMouthShapeState(myVolumeM);
        }
      };

      //オーディをコンテキスト
      // audioContext.current = new AudioContext();
      // //ここでmediaStreamを入れる
      // const audioSource = audioContext.current.createMediaStreamSource(mediaStream.current);
      // const analyser = audioContext.current.createAnalyser();
      // analyser.fftSize = 512;
      // analyser.minDecibels = -127;
      // analyser.maxDecibels = 0;
      // analyser.smoothingTimeConstant = 0.4;
      // audioSource.connect(analyser);
      // const volumes = new Uint8Array(analyser.frequencyBinCount);

      // //コールバック関数を登録
      // volumeCallback.current = () => {
      //   analyser.getByteFrequencyData(volumes);
      //   let volumeSum = 0;
      //   for (const volume of volumes) volumeSum += volume;
      //   const averageVolume = volumeSum / volumes.length;
      //   // Value range: 127 = analyser.maxDecibels - analyser.minDecibels;
      //   const finalVolume = (averageVolume * 100) / 127;
      //   //ボリュームを送信
      //   if (finalVolume > 30) {
      //     //console.log(finalVolume);
      //     setMouthShapeState(finalVolume);
      //   } else {
      //     setMouthShapeState(0);
      //   }
      // };

      //インターバルを登録
      //intervalRef.current = setInterval(volumeCallback.current, FPS);

      intervalRef.current = StartWorkerInterval(FPS, volumeCallback.current);

      //navigator.mediaDevices.addEventListener('devicechange', devicesChanged, false);
    } catch (e) {
      console.error('マイクエラー', e);
    }
  }

  //マイクの終了
  function disableMic(force = false) {
    //インターバルを終了
    if (intervalRef.current != null) {
      //clearInterval(intervalRef.current);
      StopWorkerInterval(intervalRef.current);
      intervalRef.current = null;

      volumeCallback.current = null;
    }

    //AudioContexを無効に
    if (audioContext.current != null) {
      audioContext.current.close();
      audioContext.current = null;
    }
  }

  //レンダー処理をfalseで返す
  return false;
});

export default MicDetect;
